import { debounceTime } from "rxjs/operators";

import {
  AfterViewChecked,
  ApplicationRef,
  Component,
  ComponentRef,
  ElementRef,
  EventEmitter,
  Input,
  HostListener,
  OnInit,
  ViewEncapsulation,
  ViewContainerRef,
  Type,
  OnDestroy,
} from "@angular/core";

import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLBadgeUpdateEvent,
  CONFIG_PROPERTY_POPOUT_COMPONENT_ID,
} from "./golden-layout-service";

import {
  GLComponentAlertStatus,
  GoldenLayoutComponent,
  GoldenLayoutServiceProfileConfig,
} from "./golden-layout-component";

import { GoldenLayoutAdditionMode } from "./golden-layout-addition-mode";
import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";
import { BfxBlotterInbox } from "../bfx-blotter-inbox/bfx-blotter-inbox";
import { BfxBlotterOrders } from "../bfx-blotter-orders/bfx-blotter-orders";
import { BfxTradeBlotterComponent } from "../bfx-blotter-trade/bfx-trade-blotter.component";
import { BfxRiskTradeBlotterComponent } from "../bfx-blotter-risk-trade/bfx-risk-trade-blotter.component";

import { BfxInterventionBlotterComponent } from "../bfx-blotter-intervention/bfx-intervention-blotter.component";
import { BfxOrderAuditComponent } from "../bfx-order-audit/bfx-order-audit.component";
import { BfxOrderBlotterAuditComponent } from "../bfx-order-audit/bfx-order-blotter-audit.component";
import { BfxOrderCancelComponent } from "../bfx-order-cancel/bfx-order-cancel.component";
import { BfxOrderTransferComponent } from "../bfx-order-transfer/bfx-order-transfer.component";
import { BfxOrderTakeComponent } from "../bfx-order-take/bfx-order-take.component";
import { BfxOrderForceTakeComponent } from "../bfx-order-take/bfx-order-force-take.component";
import { BfxOrderDetailsComponent } from "../bfx-order-details/bfx-order-details.component";
import { BfxFindDealsComponent } from "../bfx-find-deals/bfx-find-deals.component";
import { BfxFindOrdersComponent } from "../bfx-find-orders/bfx-find-orders.component";
import { BfxScratchPadComponent } from "../bfx-blotter-scratchpad/bfx-scratchpad.component";
import { BfxHedgeOrderMonitorComponent } from "../bfx-hedge-order-monitor/bfx-hedge-order-monitor.component";

// order entry components - start

// order entry components - end
import { BfxOrderRecapComponent } from "../bfx-order-recap/bfx-order-recap.component";
import { BfxNotificationViewerComponent } from "../bfx-notification-application/bfx-notification-viewer.component";
import { BfxUserSettingsComponent } from "../bfx-user-settings/bfx-user-settings.component";
import { BfxBlotterFilterManagerComponent } from "../bfx-blotter-filter/bfx-blotter-filter-manager.component";

import { Subject, Subscription } from "rxjs";

import { SystemConfigPromiseService } from "shared/auth-services";
import { BfxDealDetailsComponent } from "../bfx-deal-details/bfx-deal-details.component";
import { BfxContactManagerComponent } from "../bfx-contact-manager/bfx-contact-manager.component";
import { BfxContactEditComponent } from "../bfx-contact-manager/bfx-contact-edit.component";
import { BfxClientTraderEditComponent } from "../bfx-contact-manager/bfx-client-trader-edit.component";
import { BfxDetailFillComponent } from "../bfx-detail-fill/bfx-detail-fill.component";
import { BfxOrderPauseResumeComponent } from "../bfx-order-pauseresume/bfx-order-pauseresume.component";
import { BmarkSummaryContainerComponent } from "../bfx-bmark-summary/bmark-summary-container.component";

import $ from "./golden-layout-dom";

// let CircularJSON = require('circular-json');

const FLASH_INTERVAL: number = 1000;

import { SysFeatures, Roles } from "shared/cubiq-services";
import { OEScreenContainerComponent } from "../order-entry/interface/oe-screen-container.component";
import { BfxLadderOrders } from "../bfx-ladder-orders/bfx-ladder-orders";
import { BfxAlgoMonitor } from "../bfx-algo-monitor/bfx-algo-monitor";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { ELEMENT_STACK_ID } from "./golden-layout-popout-container";
import { ManualPricingContainerComponent } from "../bfx-blotter-intervention/manual-pricing/manual-pricing-container.component";
import { BfxBlotterInboxService } from "../bfx-blotter-inbox/bfx-blotter-inbox.service";
import { BfxBlotterOpsIntComponent } from "../bfx-blotter-ops-int/bfx-blotter-ops-int.component";
import { BfxBlotterOpsIntService } from "../bfx-blotter-ops-int/services/bfx-blotter-ops-int.service";
import { BfxConnectionMonitorComponent } from "../bfx-connection-monitor/bfx-connection-monitor.component";
import { BfxConnectionMonitorService } from "../bfx-connection-monitor/bfx-connection-monitor.service";
import { BfxOrderBlotterAuditService } from "../bfx-order-audit/bfx-order-blotter-audit.service";

import { LoggerService } from "@bfx/logger";
import { GoldenLayoutItemContainerContent } from "./golden-layout-item-container-content";
import { GoldenLayoutPopout } from "./golden-layout-popout";
import { NullProtoObject } from "../../shared/helper-services/null-proto-object";
import { FwdRollPricingComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/fwd-roll-pricing.component";
import { BfxATDLDesignerComponent } from "app/bfx-atdl-designer/bfx-atdl-designer.component";
import { BFXDomHelper } from "app/bfx-common/helpers/bfx-dom-helper";
import { DomHandler } from "@bfx/primeng/dom";
import { Rect } from "shared/native-desktop/NativeDesktopData";
import { BfxOrderFillNowComponent } from "app/bfx-order-fill-now/bfx-order-fill-now.component";
import { BfxAppStatusService } from "app/bfx-common/services/bfx-app-status.service";
import { ConnectionStatusPromiseService } from "shared/broker-client-services";
import * as CubiqTS from "../../shared/cubiq-model-multi-asset";
import { BfxDialogData } from "../bfx-dialogs/models/bfx-dialog-data.model";
import { BfxDialogCommand } from "../bfx-dialogs/models/bfx-dialog-command.enum";

const logger = LoggerService.for(__dirname);

@Component({
  selector: "golden-layout",
  templateUrl: "./golden-layout.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GoldenLayout implements OnInit, OnDestroy, AfterViewChecked {
  @Input() glConfig: any;

  GoldenLayoutElement: ElementRef;
  private _goldenLayout: Promise<any>;

  private _goldenLayoutRegistration: Promise<any>;
  private _goldenLayoutInitReady: Promise<any>;
  private _goldenLayoutResolve: Function;

  private bfxLadderBlotterId: number = 0;
  /*    private bfxTradeBlotterId: number = 0;
        private bfxInterventionBlotterId: number = 0;*/
  private _ngViewCheckCount: number = 0;

  //private bfxBenchmarkSummaryFactory: ComponentFactory<BmarkSummaryContainerComponent>;
  private resizes: EventEmitter<string>;
  // count of checks resulting in actions
  private componentTypes: NullProtoObject<Type<any>> = Object.create(null);

  private canViewOrderBlotters: boolean;
  private canViewAlgoMonitor: boolean;
  private canViewQuoteBlotters: boolean;
  private canViewTradesBlotters: boolean;
  private canViewRiskTradeBlotter: boolean;
  private canViewInboxBlotter: boolean;
  private canViewDealerInterventionBlotters: boolean;
  private canViewRfqDealerInterventionBlotters: boolean;
  private canViewOperationsInterventionBlotter: boolean;
  private canViewConnectionMonitor: boolean;
  private canViewFindOrders: boolean;
  private canViewFindDeals: boolean;
  private canViewScratchPad: boolean;
  private benchmarksEnabled: boolean;
  private canViewBenchmarkSummary: boolean;
  private riskRoutingEnabled: boolean;

  private maxBlotterCount: number = 10;
  private maxClientTradeBlotterCount: number = 3;
  private maxRiskTradeBlotterCount: number = 3;
  private blotterCount: number = 0;

  private flashTimer: any = null;
  private componentNames = new Set<string>();
  private componentRegistrationPromises: Array<Promise<void>> = [];
  private updatableBlotterTypes: Array<any> = [
    "BfxBlotterOrders",
    "BfxTradeBlotterComponent",
    "BfxRiskBlotterComponent",
    "BfxInterventionBlotterComponent",
    "BfxLadderOrders",
    "BmarkSummaryContainerComponent",
    "BfxBlotterOpsIntComponent",
    "BfxAlgoMonitor",
  ];

  private shouldFlash: boolean = false;

  private notificationConfig: any = {};

  private notificationData: any = {};
  private nativeWindowState: any = {};

  public loadSubject: Subject<void> = new Subject<void>();

  public refreshSubject: Subject<void> = new Subject<void>();
  public dragStartSubject: Subject<void> = new Subject<void>();

  public pendingSingletonNewDashbordItem = new Set<DashboardItemType>();

  public serviceProfileConfigMap = new Map<string, GoldenLayoutServiceProfileConfig>();
  // object must be safe to json serialize
  public serviceProfileConfigComponentConfigMap = new Map<
    GoldenLayoutServiceProfileConfig,
    object
  >();
  /** Subscriptions for app alerts */
  private alertSubscriptions: Subscription[] = [];
  /** Does this GL instance support native desktop extensions? */
  private isDesktop: boolean = false;

  constructor(
    GoldenLayoutElement: ElementRef,
    private applicationRef: ApplicationRef,
    private viewContainerRef: ViewContainerRef,
    private goldenLayoutService: GoldenLayoutService,
    private systemConfigService: SystemConfigPromiseService,
    private blotterInboxService: BfxBlotterInboxService,
    private blotterOpsIntService: BfxBlotterOpsIntService,
    private blotterAuditService: BfxOrderBlotterAuditService,
    private connectionMonitorService: BfxConnectionMonitorService,
    private connectionStatusService: ConnectionStatusPromiseService,
    private appStatusService: BfxAppStatusService,
  ) {
    this.GoldenLayoutElement = GoldenLayoutElement;
    this.goldenLayoutService.goldenLayout = this;

    /** event stream for redrawing GL after resize-related events */
    this.resizes = new EventEmitter<string>();
    this.resizes.pipe(debounceTime(500)).subscribe((source) => {
      this._goldenLayout.then(
        (goldenLayout: any) => {
          goldenLayout.updateSize();
        },
        (err: any) => {
          logger.out.info("golden layout initalization failed: " + err);
        },
      );
    });

    this._goldenLayout = new Promise<any>((resolve) => {
      this._goldenLayoutResolve = resolve;
    });

    this.loadSubject.subscribe(() => {
      // everything is visible and layout is complete

      this.goldenLayoutService.loadProfileZoomLevel();
    });
  }

  ngOnInit() {
    this.isDesktop = NativeDesktopSupport.isNativeDesktopContainer();

    // Subscribe for events that can change the internal size of the container
    const connSubscription = this.connectionStatusService
      .getConnectionEvents()
      .subscribe(() => this.processConnectionStatusChange());
    const statusSubscription = this.appStatusService.castChange.subscribe(() =>
      this.processPanicStatusChange(),
    );
    this.alertSubscriptions.push(connSubscription);
    this.alertSubscriptions.push(statusSubscription);

    this._goldenLayoutInitReady = new Promise<any>((resolveInitReady) => {
      this._goldenLayoutRegistration = new Promise<any>((resolveRegistration) => {
        Promise.all<any>([
          this.systemConfigService.canViewOrderBlotters(),
          this.systemConfigService.canViewQuoteBlotters(),
          this.systemConfigService.canViewTradesBlotters(),
          this.systemConfigService.canViewInboxBlotter(),
          this.systemConfigService.canViewDealerInterventionBlotters(),
          this.systemConfigService.canViewRfqDealerInterventionBlotters(),
          this.systemConfigService.canViewOperationsInterventionBlotter(),
          this.systemConfigService.canViewConnectionMonitor(),
          this.systemConfigService.canViewFindOrders(),
          this.systemConfigService.canViewFindDeals(),
          this.systemConfigService.canViewScratchPad(),
          this.systemConfigService.areBenchmarksEnabled(), //10
          this.systemConfigService.hasRole(Roles.ROLE_VIEW_BENCHMARK_SUMMARY_RISK), //11
          this.systemConfigService.hasRole(Roles.ROLE_VIEW_BENCHMARK_SUMMARY_FWD), //12
          this.systemConfigService.hasRole(Roles.ROLE_VIEW_BENCHMARK_SUMMARY_ORDERS), //13
          this.systemConfigService.hasRole(Roles.ROLE_VIEW_BENCHMARK_SUMMARY_HEDGE), //14
          this.systemConfigService.hasRole(Roles.ORDER_BENCHMARK_MANUAL_RISK_ROUTE), //15
          this.systemConfigService.getSystemConfig(SysFeatures.maxBlotters), //15
          this.systemConfigService.getSystemConfig(SysFeatures.maxClientTradeBlotters),
          this.systemConfigService.getSystemConfig(SysFeatures.maxRiskTradeBlotters),
          this.systemConfigService.canViewAlgoMonitor(),
          this.systemConfigService.canViewRiskTradesBlotters(),
        ]).then(
          ([
            canViewOrderBlotters,
            canViewQuoteBlotters,
            canViewTradesBlotters,
            canViewInboxBlotter,
            canViewDealerInterventionBlotters,
            canViewRfqDealerInterventionBlotters,
            canViewOperationsInterventionBlotter,
            canViewConnectionMonitor,
            canViewFindOrders,
            canViewFindDeals,
            canViewScratchPad,
            benchmarksEnabled,
            canViewBenchmarkSummarySpotRisk,
            canViewBenchmarkSummaryFwdRisk,
            canViewBenchmarkSummaryOrders,
            canViewBenchmarkSummaryHedge,
            riskRoutingEnabled,
            maxBlotterCountValue,
            maxClientTradeBlotterCountValue,
            maxRiskTradeBlotterCountValue,
            canViewAlgoBlotters,
            canViewRiskTradeBlotter,
          ]) => {
            this.canViewOrderBlotters = canViewOrderBlotters;
            this.canViewQuoteBlotters = canViewQuoteBlotters;
            this.canViewTradesBlotters = canViewTradesBlotters;
            this.canViewInboxBlotter = canViewInboxBlotter;
            this.canViewDealerInterventionBlotters = canViewDealerInterventionBlotters;
            this.canViewRfqDealerInterventionBlotters = canViewRfqDealerInterventionBlotters;
            this.canViewOperationsInterventionBlotter = canViewOperationsInterventionBlotter;
            this.canViewConnectionMonitor = canViewConnectionMonitor;
            this.canViewFindOrders = canViewFindOrders;
            this.canViewFindDeals = canViewFindDeals;
            this.canViewScratchPad = canViewScratchPad;
            this.benchmarksEnabled = benchmarksEnabled;
            this.canViewBenchmarkSummary =
              canViewBenchmarkSummarySpotRisk ||
              canViewBenchmarkSummaryFwdRisk ||
              canViewBenchmarkSummaryOrders ||
              canViewBenchmarkSummaryHedge;
            this.riskRoutingEnabled = riskRoutingEnabled;
            this.canViewAlgoMonitor = canViewAlgoBlotters;
            this.canViewRiskTradeBlotter = canViewRiskTradeBlotter;
            try {
              const value = parseInt(maxBlotterCountValue);
              if (!isNaN(value)) {
                this.maxBlotterCount = value;
              }
            } catch (err) {
              logger.out.warn("Failed to load max blotter count system parameter");
            }
            try {
              const value = parseInt(maxClientTradeBlotterCountValue);

              if (!isNaN(value)) {
                this.maxClientTradeBlotterCount = value;
              }
            } catch (err) {
              logger.out.warn("Failed to load max blotter count system parameter");
            }
            try {
              const value = parseInt(maxRiskTradeBlotterCountValue);

              if (!isNaN(value)) {
                this.maxRiskTradeBlotterCount = value;
              }
            } catch (err) {
              logger.out.warn("Failed to load max blotter count system parameter");
            }

            this.goldenLayoutService.getProfileConfiguration().then((value) => {
              let goldenLayout: any = null;
              let root =
                this.GoldenLayoutElement.nativeElement.querySelector(".golden-layout-target");

              this._goldenLayoutRegistration.then(() => {
                // restore service + singleton component configs
                if (value != null && value.serviceProfileConfig != null) {
                  Object.keys(value.serviceProfileConfig).forEach((componentName) => {
                    let config = value.serviceProfileConfig[componentName];

                    if (this.serviceProfileConfigMap.has(componentName)) {
                      let service = this.serviceProfileConfigMap.get(componentName);

                      service.setServiceConfiguration(config.service);
                      this.serviceProfileConfigComponentConfigMap.set(service, config.component);
                    }
                  });
                }
              });

              this.registerBlotters();

              this.registerModule({
                "bfx-order-blotter-audit": BfxOrderBlotterAuditComponent,
              });
              this.registerModule({
                "bfx-order-cancel": BfxOrderCancelComponent,
              });
              this.registerModule({
                "bfx-order-transfer": BfxOrderTransferComponent,
              });
              this.registerModule({
                "bfx-order-take": BfxOrderTakeComponent,
              });
              this.registerModule({
                "bfx-order-force-take": BfxOrderForceTakeComponent,
              });
              this.registerModule({
                "bfx-order-fill-now": BfxOrderFillNowComponent,
              });

              // to preview strategy viewer stand-alone
              //this.registerModule({ 'bfx-order-details': BfxStrategyViewerComponent });
              this.registerModule({
                "bfx-order-details": BfxOrderDetailsComponent,
              });
              this.registerModule({
                "bfx-order-entry-screen": OEScreenContainerComponent,
              });

              if (this.canViewFindOrders)
                this.registerModule({
                  "bfx-find-orders": BfxFindOrdersComponent,
                });

              if (this.canViewFindDeals)
                this.registerModule({
                  "bfx-find-deals": BfxFindDealsComponent,
                });

              this.registerModule({
                "bfx-order-recap": BfxOrderRecapComponent,
              });
              this.registerModule({
                "bfx-notification-viewer": BfxNotificationViewerComponent,
              });
              this.registerModule({
                "bfx-user-settings": BfxUserSettingsComponent,
              });
              this.registerModule({
                "bfx-filter-manager": BfxBlotterFilterManagerComponent,
              });
              this.registerModule({
                "bfx-deal-details": BfxDealDetailsComponent,
              });
              this.registerModule({
                "bfx-contact-manager": BfxContactManagerComponent,
              });
              this.registerModule({
                "bfx-contact-edit": BfxContactEditComponent,
              });
              this.registerModule({
                "bfx-client-trader-edit": BfxClientTraderEditComponent,
              });
              // this.registerModule({ 'bfx-acceptance-control-settings-new': BfxAcceptanceControlsSettingsNewComponent });
              // this.registerModule({ 'bfx-acceptance-control-settings-edit': BfxAcceptanceControlsSettingsEditComponent });
              this.registerModule({
                "bfx-detail-fill": BfxDetailFillComponent,
              });
              this.registerModule({
                "bfx-order-pauseresume": BfxOrderPauseResumeComponent,
              });
              if (this.benchmarksEnabled && this.canViewBenchmarkSummary)
                this.registerModule({
                  "bmark-summary-container": BmarkSummaryContainerComponent,
                });

              if (this.riskRoutingEnabled)
                this.registerModule({
                  "bfx-hedge-order-monitor": BfxHedgeOrderMonitorComponent,
                });

              this.registerModule({
                "manual-pricing-container": ManualPricingContainerComponent,
              });

              this.registerModule({
                "bfx-fwd-roll-pricing": FwdRollPricingComponent,
              });

              this.registerModule({
                "bfx-atdl-designer": BfxATDLDesignerComponent,
              });

              if (this.canViewAlgoMonitor) {
                this.registerModule({
                  "bfx-algo-monitor": BfxAlgoMonitor,
                });
              }

              this._goldenLayout.then((goldenLayout) => {
                this.wrapComponents(goldenLayout);

                this.goldenLayoutService.registerComponentState(() => {
                  return this.retrieveGoldenLayoutContent();
                });

                this.goldenLayoutService.subjectBadge.subscribe((event: GLBadgeUpdateEvent) => {
                  let items: Array<any> = goldenLayout.root.getItemsByFilter(
                    (item: any) =>
                      item.type == "component" && item.instance.instance == event.component,
                  );
                  items.forEach((item: any) => {
                    let children: Array<any> = Array.from(item.container.tab.element[0].children);
                    let badge: Element = children.filter((node: any) =>
                      node.classList.contains("badge"),
                    )[0];
                    if (badge != null) {
                      badge.innerHTML = event.badgeCount > 0 ? "" + event.badgeCount : "";
                    }
                  });
                });

                this.flashTimer = setInterval(this.updateFlash.bind(this), FLASH_INTERVAL);
                this.goldenLayoutService.subjectFlash.subscribe(this.updateFlash.bind(this));
              });

              let layout = this.canViewOrderBlotters
                ? this.getDefaultConfiguration()
                : this.getEmptyConfiguration();

              if (value != null) {
                value = this.validiateProfileConfiguration(value);
                // preserve root stack wrapper + header size from default config
                layout.content = value.content;
              }

              try {
                goldenLayout = new $.fn.LayoutManager(layout, root);
              } catch (e) {
                // not everyone has perms for order-blotter
                layout = this.getEmptyConfiguration();
                goldenLayout = new $.fn.LayoutManager(layout, root);
              }

              goldenLayout.on("stackCreated", this.onStackCreated.bind(this));
              goldenLayout.on("stateChanged", this.onStateChanged.bind(this));
              goldenLayout.on("tabCreated", this.onTabCreated.bind(this));
              goldenLayout.on("initialised", this.onInitialized.bind(this, goldenLayout));
              goldenLayout.on("itemDropped", this.onItemDropped.bind(this));
              // dragListener has been enchanced to emit this after drag proxy creation
              goldenLayout.on(
                "itemDragStart",
                (() => {
                  this.dragStartSubject.next();
                }).bind(this),
              );

              goldenLayout.on(
                "itemDestroyed",
                (() => {
                  this.refreshSubject.next();
                }).bind(this),
              );

              // DO not restore main window if it was saved in minimized state as may disable maximise functionality
              const wasMinimized = value?.nativeWindowState?.state === "minimized";
              const restoredState = !wasMinimized ? value?.nativeWindowState : null;

              resolveRegistration({
                goldenLayout: goldenLayout,
                popout: value != null && Array.isArray(value.popout) ? value.popout : [],
                notification:
                  value != null && value.notification != null ? value.notification : null,
                nativeWindowState: restoredState,
              });
            });
          },
        );
      });

      Promise.all([this._goldenLayoutRegistration, ...this.componentRegistrationPromises]).then(
        ([data]) => {
          this._goldenLayout.then(() => {
            try {
              if (data.notification != null) {
                if (this.isDesktop) {
                  this.goldenLayoutService.setNotificationConfig(data.notification);
                } else {
                  this.notificationData = data.notification;
                }
              }
            } catch (e) {
              logger.out.error(`${this.constructor.name}: Error loading notification config`, e);
            }

            if (this.isDesktop) {
              // data.nativeWindowState == null is a supported config
              // will create default window state
              NativeDesktopSupport.resolveNativeWindowState(data.nativeWindowState);
            } else if (data.nativeWindowState != null) {
              // not used - but preserve if profile is saved in browser
              this.nativeWindowState = data.nativeWindowState;
            }

            let popout = [];

            if (data.popout != null && Array.isArray(data.popout)) {
              popout = this.filterUtilityPopout(data);
            }

            const pendingCount = popout.length;
            let openCount = 0;

            if (pendingCount > 0) {
              popout.forEach((config) => {
                config.itemConfig.windowConfig = config.windowConfig;
                config = config.itemConfig;
                config.oneTimePoput = true;
                delete config.type;
                delete config[CONFIG_PROPERTY_POPOUT_COMPONENT_ID];
                this.goldenLayoutService.launchFromDashboard(
                  config.componentName,
                  config.componentType,
                  config.allowMultiples,
                  GoldenLayoutAdditionMode.DEFAULT,
                  config,
                );

                this.goldenLayoutService.popoutNativeShown$.subscribe(() => {
                  openCount++;
                  if (pendingCount === openCount) {
                    this.loadSubject.next();
                  }
                });
              });
            } else {
              // No popups to load, apply zoom level
              this.loadSubject.next();
            }
          });

          resolveInitReady(data.goldenLayout);
        },
      );
    });

    if (this.isDesktop) {
      NativeDesktopSupport.desktop.on("closed", (frameId) => {
        try {
          let wnd = NativeDesktopSupport.getWindowById(frameId);
          if (wnd != null && (wnd as any).popoutId != null) {
            this.goldenLayoutService.deletePopoutComponent(wnd["popoutId"]);
          }
        } catch (e) {
          logger.out.error("Error closing window ... ", e);
        }
      });
    }
  }

  ngOnDestroy() {
    this.alertSubscriptions.forEach((subscription) => subscription.unsubscribe());
    this.alertSubscriptions = [];
  }

  /**
   * UI has received a change to panic
   */
  processPanicStatusChange() {
    this.resizes.next("alert");
  }

  /**
   * UI has received a change to connection status
   */
  private processConnectionStatusChange(): void {
    this.resizes.next("connection");
  }

  private filterUtilityPopout(data) {
    return data.popout.filter((config) => {
      // Don't restore popout utility windows
      if (config.itemConfig.canRestore === false) {
        logger.out.info(
          `Not restoring saved view - disabled - type(${config.itemConfig.componentType})`,
        );
        return false;
      }
      // Trap any unsupported legacy popups - the switch below can
      // be removed once all users and their layouts have moved to 4.12.0
      switch (config.itemConfig.componentType) {
        case DashboardItemType.FwdRollPricing:
        case DashboardItemType.DetailFill:
          logger.out.warn(
            `Not restoring legacy view - data context required - type(${config.itemConfig.componentType})`,
          );
          return false;
        default:
          break;
      }

      return true;
    });
  }

  /**
   * Works ok on desktop
   */
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.resizes.next("window");
  }

  ngAfterViewChecked() {
    if (this._ngViewCheckCount === 0) {
      this._ngViewCheckCount++;
    } else if (this._ngViewCheckCount === 1) {
      logger.out.info("golden layout ngAfterContentInit");

      // this.goldenLayoutService.subscribeNewFromDashboard(res => { this.newFromDashboard(res) });

      this._goldenLayoutInitReady.then(
        (goldenLayout: any) => {
          goldenLayout.init();

          this._goldenLayoutResolve(goldenLayout);

          this._goldenLayoutResolve = null;
        },
        (err: any) => {
          logger.out.info("golden layout initalization failed: " + err);
        },
      );
      this._ngViewCheckCount++;
    }
  }

  /**
   * see system.maxLadders && system.maxTradeBlotters in DB
   */
  protected checkBlotterLimit(type: DashboardItemType, config: any): Promise<boolean> {
    return new Promise<boolean>((res, rej) => {
      if (
        (type == DashboardItemType.OrdersBlotter ||
          type == DashboardItemType.OrdersLadder ||
          type == DashboardItemType.TradesBlotter ||
          type == DashboardItemType.RiskTradeBlotter) &&
        !config.docking
      ) {
        this._goldenLayout.then((goldenLayout: any) => {
          let types = new Set(
            type === DashboardItemType.TradesBlotter || type == DashboardItemType.RiskTradeBlotter
              ? [DashboardItemType.TradesBlotter, DashboardItemType.RiskTradeBlotter]
              : [DashboardItemType.OrdersBlotter, DashboardItemType.OrdersLadder],
          );
          let names = new Set(
            type === DashboardItemType.TradesBlotter || type == DashboardItemType.RiskTradeBlotter
              ? ["bfx-trade-blotter", "bfx-risk-trade-blotter"]
              : ["bfx-blotter-orders", "bfx-ladder-orders", "bfx-algo-monitor"],
          );
          let maxCount =
            type === DashboardItemType.TradesBlotter
              ? this.maxClientTradeBlotterCount
              : type == DashboardItemType.RiskTradeBlotter
                ? this.maxRiskTradeBlotterCount
                : this.maxBlotterCount;
          let items: Array<any> = goldenLayout._getAllContentItems();
          let blotterItems: Array<any> = items.filter((value) => names.has(value.componentName));

          let components: Array<any> = this.goldenLayoutService
            .getPopoutComponents()
            .filter((value: any) => types.has(value._config.componentType) && !value.docking);
          res(blotterItems.length + components.length < maxCount);
        });
      } else {
        res(true);
      }
    });
  }

  // TODO Refactor to use registerModule & simplify
  registerBlotters() {
    const goldenLayoutComponent = this;

    //this.bfxBenchmarkSummaryFactory =  this.resolver.resolveComponentFactory(BmarkSummaryContainerComponent);

    let createNewBlotterFn = function createNewBlotterFn(this: null, container, state) {
      // this is the real constructor used by GoldenLayout's
      // lm.items.Component() as ComponentConstructor to create blotters
      let containerComponent = goldenLayoutComponent.viewContainerRef.createComponent(
        GoldenLayoutItemContainerContent,
      );
      let containerNode = null;
      let containerResizes: EventEmitter<void> = new EventEmitter<void>();
      let component: ComponentRef<any> = null;

      if (container.getElement) {
        containerNode = container.getElement()[0];
        containerNode.replaceWith(containerComponent.instance.getElement());
        containerNode = containerComponent.instance.getElement();
        containerNode.dataset.id = ++goldenLayoutComponent.bfxLadderBlotterId;
      }

      if (
        container != null &&
        container._config != null &&
        container._config.stackId != null &&
        container._config.popoutComponentId
      ) {
        let popoutComponentId: string = container._config.popoutComponentId;
        component = goldenLayoutComponent.goldenLayoutService.getPopoutComponent(popoutComponentId);
      } else if ("bfx-blotter-scratchpad" === state.componentName) {
        container.componentRef =
          containerComponent.instance.createComponent(BfxScratchPadComponent);
      }

      if (component != null) {
        container.componentRef = component;
        container._contentElement[0].appendChild(component.location.nativeElement);
      } else {
        if ("bfx-blotter-orders" === state.componentName) {
          container.componentRef = containerComponent.instance.createComponent(BfxBlotterOrders);
        } else if ("bfx-blotter-inbox" === state.componentName) {
          container.componentRef = containerComponent.instance.createComponent(BfxBlotterInbox);
        } else if ("bfx-blotter-ops-int" === state.componentName) {
          container.componentRef =
            containerComponent.instance.createComponent(BfxBlotterOpsIntComponent);
        } else if ("bfx-trade-blotter" === state.componentName) {
          container.componentRef =
            containerComponent.instance.createComponent(BfxTradeBlotterComponent);
        } else if ("bfx-risk-trade-blotter" === state.componentName) {
          container.componentRef = containerComponent.instance.createComponent(
            BfxRiskTradeBlotterComponent,
          );
        } else if ("bfx-intervention-blotter" === state.componentName) {
          container.componentRef = containerComponent.instance.createComponent(
            BfxInterventionBlotterComponent,
          );
        } else if ("bfx-ladder-orders" === state.componentName) {
          container.componentRef = containerComponent.instance.createComponent(BfxLadderOrders);
        } else if ("bfx-algo-monitor" === state.componentName) {
          container.componentRef = containerComponent.instance.createComponent(BfxAlgoMonitor);
        } else if ("bfx-connection-monitor" === state.componentName) {
          container.componentRef = containerComponent.instance.createComponent(
            BfxConnectionMonitorComponent,
          );
        }
      }

      if (container.componentRef != null) {
        if (container.on) {
          container.on("resize", function (this: null, contentItem) {
            containerResizes.emit();
          });

          container.parent.on(
            "resize",
            function (this: null, contentItem) {
              containerResizes.emit();
            },
            this,
          );

          container.parent.parent.on(
            "resize",
            function (this: null, contentItem) {
              containerResizes.emit();
            },
            this,
          );

          containerResizes.pipe(debounceTime(333)).subscribe(() => {
            requestAnimationFrame(function (this: null) {
              container.componentRef.instance.resize();
            });
          });
        }
        goldenLayoutComponent.updateContainerConfigData(container);
        goldenLayoutComponent.registerComponentRef(
          container,
          container.componentRef,
          container._config,
        );
      }

      return container.componentRef;
    };

    if (this.canViewQuoteBlotters) this.registerComponent("bfx-blotter-quotes", createNewBlotterFn);

    if (this.canViewOrderBlotters) {
      this.registerComponent("bfx-blotter-orders", createNewBlotterFn);
      this.registerComponent("bfx-ladder-orders", createNewBlotterFn);
    }

    if (this.canViewInboxBlotter)
      this.registerComponent("bfx-blotter-inbox", createNewBlotterFn, this.blotterInboxService);

    if (this.canViewTradesBlotters) this.registerComponent("bfx-trade-blotter", createNewBlotterFn);

    if (this.canViewRiskTradeBlotter)
      this.registerComponent("bfx-risk-trade-blotter", createNewBlotterFn);

    if (this.canViewDealerInterventionBlotters)
      this.registerComponent("bfx-intervention-blotter", createNewBlotterFn);

    if (this.canViewScratchPad)
      this.registerComponent("bfx-blotter-scratchpad", createNewBlotterFn);

    if (this.canViewOperationsInterventionBlotter)
      this.registerComponent("bfx-blotter-ops-int", createNewBlotterFn, this.blotterOpsIntService);

    if (this.canViewConnectionMonitor)
      this.registerComponent("bfx-connection-monitor", createNewBlotterFn);
  }

  registerModule(
    components: { [key: string]: Type<any> },
    glServiceProfileConfig: GoldenLayoutServiceProfileConfig = null,
  ): void {
    const glComponent = this;

    for (let a in components) {
      this.componentTypes[a] = components[a];

      this.registerComponent(
        a,
        function (this: null, container, state) {
          // this is the real constructor used by GoldenLayout's
          // lm.items.Component() as ComponentConstructor to create non-blotter components
          return glComponent.createNewComponent.call(glComponent, container, state);
        },
        glServiceProfileConfig,
      );
    }
  }

  createNewComponent(container: any, state: any): ComponentRef<any> {
    // let popoutProfileConfigData =
    let popoutConfig: GLPopoutConfiguration = Object.assign(
      new GLPopoutConfiguration(),
      container._config,
    );
    let componentRef: ComponentRef<any> = null;

    let component: ComponentRef<any> = null;

    if (
      container != null &&
      container._config != null &&
      container._config.stackId != null &&
      container._config.popoutComponentId
    ) {
      let popoutComponentId: string = container._config.popoutComponentId;
      component = this.goldenLayoutService.getPopoutComponent(popoutComponentId);
      // this.goldenLayoutService.deletePopoutComponent(popoutComponentId);
    }

    if (component == null) {
      if (
        popoutConfig.initialState == GLPopoutState.POPOUT ||
        container == null ||
        container.getElement == null
      ) {
        componentRef = this.viewContainerRef.createComponent(
          this.componentTypes[container._config.componentName],
        );
      } else {
        let containerNode = container.getElement()[0];
        let containerComponent = this.viewContainerRef.createComponent(
          GoldenLayoutItemContainerContent,
        );
        componentRef = containerComponent.instance.createComponent(
          this.componentTypes[container._config.componentName],
        );
        containerNode.replaceWith(containerComponent.instance.getElement());
      }

      if (componentRef.instance["glInit"]) {
        componentRef.instance["glInit"](container._config.data, container, state);
      }

      this.registerComponentRef(container, componentRef, container._config);
    } else {
      this.registerComponentRef(container, componentRef, container._config);
    }

    return componentRef;
  }

  registerComponent(
    componentName: any,
    createFn: any,
    service: GoldenLayoutServiceProfileConfig = null,
  ) {
    this.componentNames.add(componentName);

    if (service != null) {
      this.serviceProfileConfigMap.set(componentName, service);
    }

    this.componentRegistrationPromises.push(
      new Promise<void>((res) => {
        this._goldenLayoutRegistration.then((data) => {
          data.goldenLayout.registerComponent(componentName, createFn);
          res();
        });
      }),
    );
  }

  registerComponentRef(container: any, componentRef: ComponentRef<any>, configuration: any) {
    componentRef["_config"] = configuration;

    container.componentRef = componentRef;

    this.updateContainerConfigData(container);
  }

  /**
   *
   * @param goldenLayout != this
   */
  wrapComponents(goldenLayout: any) {
    const goldenLayoutComponent = this;
    const goldenLayoutService = this.goldenLayoutService;
    goldenLayout._wrappedComponents = [];

    for (let component in goldenLayout._components) {
      let currentComponent: any = goldenLayout._components[component];
      goldenLayout._wrappedComponents[component] = currentComponent;

      goldenLayout._components[component] = function (container, state) {
        let componentRef: ComponentRef<any> = null;

        if (container._config[CONFIG_PROPERTY_POPOUT_COMPONENT_ID]) {
          let componentId: string = container._config[CONFIG_PROPERTY_POPOUT_COMPONENT_ID];
          componentRef = goldenLayoutService.getPopoutComponent(componentId);

          if (
            componentRef != null &&
            componentRef.instance != null &&
            componentRef.instance["docked"] &&
            this.isDesktop
          ) {
            componentRef.instance["docked"]();
          }

          goldenLayoutService.deletePopoutComponent(componentId);
        }

        if (!componentRef) {
          componentRef = goldenLayout._wrappedComponents[component].call(this, container, state);
          if (
            componentRef != null &&
            container._config &&
            componentRef.instance &&
            componentRef.instance["restoreFromConfiguration"]
          ) {
            let componentName: string = container._config.componentName;
            let componentData: any = null;

            try {
              if (
                componentName != null &&
                (componentData =
                  goldenLayoutService.getSingleInstanceComponentData(componentName)) != null
              ) {
                componentRef.instance["restoreFromConfiguration"](componentData);
              } else if (container._config.data) {
                componentRef.instance["restoreFromConfiguration"](container._config.data);
              }
            } catch (e) {
              logger.out.error(
                "Failed to read component configuration " + componentName + " : " + e,
              );
            }
          }
        } else {
          let containerNode = container.getElement()[0];
          container.componentRef = componentRef;
          goldenLayoutComponent.updateContainerConfigData(container);
          containerNode.appendChild(componentRef.location.nativeElement);
        }

        if (componentRef != null && componentRef.instance["resizeDocked"] && container.on) {
          let containerResizes: EventEmitter<void> = new EventEmitter<void>();

          if (componentRef["registeredDockEventsSubscription"]) {
            componentRef["registeredDockEventsSubscription"].unsubscribe();
          }

          container.on("resize", (contentItem) => {
            containerResizes.emit();
          });

          container.parent.on(
            "resize",
            (contentItem) => {
              containerResizes.emit();
            },
            this,
          );

          container.parent.parent.on(
            "resize",
            (contentItem) => {
              containerResizes.emit();
            },
            this,
          );

          componentRef["registeredDockEventsSubscription"] = containerResizes
            .pipe(debounceTime(333))
            .subscribe(() => {
              requestAnimationFrame(
                function () {
                  let element: any = container["_contentElement"][0];
                  let event: any = {
                    position: {
                      top: element.offsetTop,
                      height: element.offsetLeft,
                    },
                    size: {
                      width: element.offsetWidth,
                      height: element.offsetHeight,
                    },
                  };
                  if (event.size.width > 0 && event.size.height > 0) {
                    componentRef.instance["resizeDocked"](event);
                  }
                }.bind(this),
              );
            });
        }

        return componentRef;
      }.bind(this);
    }
  }

  onStateChanged(entry: any) {
    this._goldenLayout.then((goldenLayout: any) => {
      try {
        let items: Array<any> = goldenLayout._getAllContentItems();
        let blotters: Array<any> = items.filter(
          (a) => a["componentName"] && a["componentName"] == "bfx-ladder-blotter",
        );

        if (blotters.length == 1) {
          let blotter: any = blotters[0];
          if (
            blotter.parent &&
            blotter.parent._activeContentItem &&
            blotter.parent._activeContentItem === blotters[0]
          ) {
            if (blotter.parent.header)
              blotter.parent.header.controlsContainer.find(".lm_popout").hide();
          } else {
            if (blotter.parent.header)
              blotter.parent.header.controlsContainer.find(".lm_popout").show();
          }
        } else {
          blotters.forEach((b) => {
            if (b.parent.header) {
              b.parent.header.controlsContainer.find(".lm_popout").show();
            }
          });
        }

        this.fixScrollbar();
      } catch (e) {
        logger.out.info("Could not update stack controls." + e);
      }
    });
  }

  /**
   * Called upon initialization of golden layout, it will filter out (close) any component wrapper
   * without a component instance, usefull if a saved layout's component should be skipped.
   * @param goldenLayout golden layout instance
   */
  onInitialized(goldenLayout: any): void {
    try {
      goldenLayout.root
        .getItemsByType("component")
        .filter((component: any) => component.instance.instance == null)
        .forEach((component: any) => {
          component.close();
        });
    } catch (error) {
      logger.out.info("Error cleaning up empty tabs." + error);
    } finally {
      this.refreshSubject.next();
      if (this.isDesktop) {
        NativeDesktopSupport.nativeWindowFadeIn.then(() => {
          this.refreshSubject.next();
        });
      }
    }
  }

  onItemDropped(item: any): void {
    this.refreshSubject.next();

    if (item == null || typeof item != "object") {
      return;
    }

    if (item.instance == null || typeof item.instance != "object") {
      return;
    }

    if (item.instance.instance == null || typeof item.instance.instance != "object") {
      return;
    }

    if (typeof item.instance.instance.onDropped == "function") {
      item.instance.instance.onDropped.call(item.instance.instance);
    }
  }

  fixScrollbar() {
    this._goldenLayout.then((goldenLayout: any) => {
      try {
        let items: Array<any> = goldenLayout._getAllContentItems();
        let anyblotters: Array<any> = items.filter(
          (a) => a["componentName"] && a["componentName"].indexOf("blotter") > -1,
        );
        anyblotters.forEach((b) => {
          if (
            b.parent &&
            b.parent._activeContentItem &&
            b.parent._activeContentItem === b &&
            b.container.componentRef != null
          ) {
            setTimeout(function () {
              b.container.componentRef.instance.resizeScrollBarForData();
            }, 1000);
          }
        });
      } catch (e) {
        logger.out.info("Could not update stack controls." + e);
      }
    });
  }

  onStackCreated(stack: any) {
    stack.header.controlsContainer
      .find(".lm_popout")
      .off("click")
      .on("click", this.popupStack.bind(this, stack));

    stack.id = this.generateStackId();

    Promise.all([
      this._goldenLayoutInitReady,
      this._goldenLayoutResolve,
      this._goldenLayoutRegistration,
    ]).then(() => {
      const activeChangeHandler = (componentItem: any) => {
        let component: any = componentItem?.instance?.instance;

        if (component != null && component["componentActivated"]) {
          component["componentActivated"]();
        }

        if (componentItem != null) {
          componentItem.parent
            .getItemsByFilter((item: any) => item != componentItem)
            .forEach((item: any) => {
              component = item.instance.instance;

              if (component != null && component["componentDeactivated"]) {
                component["componentDeactivated"]();
              }
            });
        }

        this.updateFlash();
      };

      stack.on("activeContentItemChanged", activeChangeHandler);
      // Ensure the handler is executed for the first item
      activeChangeHandler(stack._activeContentItem);
    });

    this.refreshSubject.next();
  }

  protected onTabCreated(tab: any): void {
    if (
      tab.contentItem.instance.instance != null &&
      tab.contentItem.instance.instance["getBadgeNumber"]
    ) {
      let badgeCount: number = tab.contentItem.instance.instance["getBadgeNumber"]();

      let element: Element = document.createElement("span");
      element.className = "badge lm_tab_badge";
      element.innerHTML = badgeCount > 0 ? "" + badgeCount : "";

      let close = tab.element.find(".lm_close_tab");
      close.before(element);
    }

    if (this.isDesktop) {
      let element: Element = document.createElement("div");
      element.className = "lm_popout";
      element.setAttribute("title", "Open in a new window");
      element.addEventListener("click", this.popupTab.bind(this, tab));

      let close = tab.element.find(".lm_close_tab");
      close.before(element);
    }

    if (
      this.updatableBlotterTypes.find((element) => {
        return (
          tab.contentItem.instance.instance != null &&
          tab.contentItem.instance.instance.getTabIdentifier != null &&
          element === tab.contentItem.instance.instance.getTabIdentifier()
        );
      }) != undefined
    ) {
      this.goldenLayoutService.tab(tab, tab.element[0].title);
    }

    const component = tab
      ? tab.contentItem
        ? tab.contentItem.container
          ? tab.contentItem.container.componentRef
            ? tab.contentItem.container.componentRef.instance
              ? tab.contentItem.container.componentRef.instance
              : null
            : null
          : null
        : null
      : null;

    if (tab && tab.closeElement) {
      tab.closeElement.off("click").on(
        "click",
        function (this: GoldenLayout, component: GoldenLayoutComponent) {
          let componentOnClose = !!component["onClose"];
          let closed = false;

          if (componentOnClose) {
            closed = component["onClose"]();
            closed = closed !== false;
          } else {
            closed = true;
          }

          if (closed) {
            this.updateServiceProfileConfig(component);
            this.goldenLayoutService.storeTabComponent(tab.contentItem);
            this.goldenLayoutService.closeTab(component.blotterId);
            tab.contentItem.remove();
          }
        }.bind(this, component),
      );
    }

    this.refreshSubject.next();
  }

  popupStack(stack: any) {
    let component: ComponentRef<any> = stack._activeContentItem.container
      .componentRef as ComponentRef<any>;
    let popout = this.viewContainerRef.createComponent(GoldenLayoutPopout);
    this.goldenLayoutService.popout(component, stack, null, popout);
  }

  popupComponent(component: ComponentRef<any>, config: any) {
    let popout = this.viewContainerRef.createComponent(GoldenLayoutPopout);
    this.goldenLayoutService.popout(component, null, config, popout);
  }

  popupTab(tab): void {
    let popout = this.viewContainerRef.createComponent(GoldenLayoutPopout);
    tab.header.parent.setActiveContentItem(tab.contentItem);
    this.goldenLayoutService.popout(tab.contentItem.instance, tab.contentItem.parent, null, popout);
  }

  glModeChange(mode: GoldenLayoutAdditionMode) {
    // is this used ??? -dc
    switch (mode) {
      case GoldenLayoutAdditionMode.DEFAULT: {
        let newItemConfig = {
          title: "Order Blotter",
          id: "Order Blotter",
          type: "component",
          componentName: "bfx-ladder-blotter",
          componentType: DashboardItemType.OrdersBlotter,
          width: 100,
          height: 100,
        };

        this._goldenLayout.then(
          (goldenLayout: any) => {
            goldenLayout.root.contentItems[0].contentItems[0].addChild(newItemConfig);
          },
          (err: any) => {
            logger.out.info("golden layout initalization failed: " + err);
          },
        );
      }
      default:
        break;
    }
  }

  newFromDashboard(descriptor: any): void {
    let type: DashboardItemType = descriptor.type;

    logger.out.info(`Open dashboard request for type '${type}'`);
    this.checkBlotterLimit(type, descriptor).then((value: boolean) => {
      if (value) {
        this.newItemFromDashboard(descriptor);
      } else {
        logger.out.warn("Cannot open window - blotter limit exceeded");
      }
    });
  }

  newItemFromDashboard(descriptor: any) {
    let dashboardItemType: DashboardItemType = descriptor.type;
    let name: string = descriptor.name ? descriptor.name : descriptor.title;

    switch (dashboardItemType) {
      case DashboardItemType.OrdersBlotter:
        this.newWindow(name, "component", "bfx-blotter-orders", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrdersLadder:
        this.newWindow(name, "component", "bfx-ladder-orders", descriptor, dashboardItemType);
        break;
      case DashboardItemType.AlgoMonitor:
        this.newWindow(name, "component", "bfx-algo-monitor", descriptor, dashboardItemType);
        break;
      case DashboardItemType.Inbox:
        descriptor["baseFilter"] = "inbox";
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-blotter-inbox", descriptor, dashboardItemType);
        break;
      case DashboardItemType.TradesBlotter:
        this.newWindow(name, "component", "bfx-trade-blotter", descriptor, dashboardItemType);
        break;
      case DashboardItemType.RiskTradeBlotter:
        this.newWindow(name, "component", "bfx-risk-trade-blotter", descriptor, dashboardItemType);
        break;
      case DashboardItemType.InterventionBlotter:
        descriptor.allowMultiples = false;
        this.newWindow(
          name,
          "component",
          "bfx-intervention-blotter",
          descriptor,
          dashboardItemType,
        );
        break;
      case DashboardItemType.FindDeals:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-find-deals", descriptor, dashboardItemType);
        break;
      case DashboardItemType.FindOrders:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-find-orders", descriptor, dashboardItemType);
        break;
      case DashboardItemType.ScratchPad:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-blotter-scratchpad", descriptor, dashboardItemType);
        break;
      case DashboardItemType.SalesScreen:
        this.newWindow(name, "component", "bfx-sales-root", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OpsIntBlotter:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-blotter-ops-int", descriptor, dashboardItemType);
        break;
      case DashboardItemType.ConnectionMonitor:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-connection-monitor", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderAudit:
        // Don't think this is used anymore - ajb
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-order-audit", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderBlotterAudit:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-order-blotter-audit", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderCancel:
        this.newWindow(name, "component", "bfx-order-cancel", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderTransfer:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-order-transfer", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderTake:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-order-take", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderForceTake:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-order-force-take", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderFillNow:
        this.newWindow(name, "component", "bfx-order-fill-now", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderDetails:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-order-details", descriptor, dashboardItemType);
        break;
      case DashboardItemType.NewOrder:
        this.newWindow(name, "component", "bfx-order-entry-screen", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderRecap:
        this.newWindow(name, "component", "bfx-order-recap", descriptor, dashboardItemType);
        break;
      case DashboardItemType.NotificationsViewer:
        this.newWindow(name, "component", "bfx-notification-viewer", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderModify:
        this.newWindow(name, "component", "bfx-order-entry-screen", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderModifyInfo:
        this.newWindow(name, "component", "bfx-order-entry-screen", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderDuplicate:
        this.newWindow(name, "component", "bfx-order-entry-screen", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderAmendMarkup:
        this.newWindow(name, "component", "bfx-order-entry-screen", descriptor, dashboardItemType);
        break;
      case DashboardItemType.Reporting:
        // this.newPlaceholderWindow(name);
        break;
      case DashboardItemType.FindOrders:
        this.newWindow(
          name,
          "component",
          "golden-layout-placeholder",
          descriptor,
          dashboardItemType,
        );
        break;
      case DashboardItemType.FindDeals:
        this.newWindow(
          name,
          "component",
          "golden-layout-placeholder",
          descriptor,
          dashboardItemType,
        );
        break;
      case DashboardItemType.UserSettings:
        this.newWindow(name, "component", "bfx-user-settings", descriptor, dashboardItemType);
        break;
      case DashboardItemType.FilterManager:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-filter-manager", descriptor, dashboardItemType);
        break;
      case DashboardItemType.DealDetails:
        descriptor.allowMultiples = false;
        const dealId = descriptor.data?.tradeDealId;
        const dealTitle = name + "- Deal " + dealId;
        this.newWindow(dealTitle, "component", "bfx-deal-details", descriptor, dashboardItemType);
        break;
      case DashboardItemType.ContactManager:
        this.newWindow(name, "component", "bfx-contact-manager", descriptor, dashboardItemType);
        break;
      case DashboardItemType.ContactEdit:
        this.newWindow(name, "component", "bfx-contact-edit", descriptor, dashboardItemType);
        break;
      case DashboardItemType.ClientTraderEdit:
        this.newWindow(name, "component", "bfx-client-trader-edit", descriptor, dashboardItemType);
        break;
      case DashboardItemType.DetailFill:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-detail-fill", descriptor, dashboardItemType);
        break;
      case DashboardItemType.OrderPauseResume:
        this.newWindow(name, "component", "bfx-order-pauseresume", descriptor, dashboardItemType);
        break;
      case DashboardItemType.BenchmarkSummary:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bmark-summary-container", descriptor, dashboardItemType);
        break;
      case DashboardItemType.HedgeOrderMonitor:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-hedge-order-monitor", descriptor, dashboardItemType);
        break;
      case DashboardItemType.ManualPricing:
        descriptor.allowMultiples = false;
        this.newWindow(
          name,
          "component",
          "manual-pricing-container",
          descriptor,
          dashboardItemType,
        );
        break;
      case DashboardItemType.FwdRollPricing:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-fwd-roll-pricing", descriptor, dashboardItemType);
        break;
      case DashboardItemType.ATDLDesigner:
        descriptor.allowMultiples = false;
        this.newWindow(name, "component", "bfx-atdl-designer", descriptor, dashboardItemType);
        break;
    }
  }

  newWindow(
    title: string,
    type: string,
    componentName: string,
    descriptor: any = {},
    dashboardItemType: DashboardItemType,
  ): void {
    let newItemConfig: any = {
      title: title,
      id: title,
      type: type,
      componentName: componentName,
      componentType: descriptor.type,
      data: descriptor.data,
      width: 100,
      height: 100,
      allowMultiples: true,
      preventActivation: false,
    };

    if (componentName == "bfx-blotter-ops-int" && descriptor.oneTimePoput) {
      // align with common behavour of GoldenLayoutService.showOpsInt()
      descriptor.preventActivation = true;
    }

    delete descriptor.type;
    Object.assign(newItemConfig, descriptor);

    // Check in case a single instance component is popped out and exit if so
    if (!newItemConfig.allowMultiples && !newItemConfig.docking) {
      let componentExistsAsPopout: boolean = false;

      let component: ComponentRef<any> = this.goldenLayoutService
        .getPopoutComponents()
        .find((component: ComponentRef<any>) => {
          if (component["_config"]) {
            componentExistsAsPopout = component["_config"].id == newItemConfig.id;
          }

          return componentExistsAsPopout;
        });

      if (componentExistsAsPopout && this.isDesktop) {
        componentExistsAsPopout = NativeDesktopSupport.getWindowById(newItemConfig.name) != null;
      }

      if (componentExistsAsPopout) {
        if (this.checkErrorDialogOnMultiple(descriptor, dashboardItemType)) return;

        if (this.isDesktop && newItemConfig && newItemConfig.name) {
          this.goldenLayoutService.restoreWindowAsPopout(
            newItemConfig.name,
            descriptor.preventActivation,
          );
        }

        if (component != null && component.instance["glUpdate"]) {
          (component.instance as GoldenLayoutComponent).glUpdate(newItemConfig);
        }

        if (componentName == "bfx-order-details") {
          this.goldenLayoutService.bringPopoutFocus(
            component?.["_config"]?.popoutComponentId,
            component["_config"].id,
          );
        }

        return;
      }
    }

    let cleanupPendingSingleton = false;

    if (this.pendingSingletonNewDashbordItem.has(dashboardItemType)) {
      logger.out.warn(
        `${this.constructor.name}.newWindow()` +
          ` no valid action found for pending singleton` +
          ` ${title} ${DashboardItemType[dashboardItemType]}`,
      );

      return;
    } else if (newItemConfig.allowMultiples === false) {
      this.pendingSingletonNewDashbordItem.add(dashboardItemType);
      cleanupPendingSingleton = true;
    }

    let popout: boolean =
      this.isDesktop &&
      (this.goldenLayoutService.shouldPopout(newItemConfig.componentName) ||
        newItemConfig.oneTimePoput);

    if (newItemConfig.oneTimePoput) {
      delete newItemConfig.oneTimePoput;
    }

    this._goldenLayout.then(
      (goldenLayout) => {
        try {
          let isNewItem =
            newItemConfig.allowMultiples ||
            goldenLayout.root.getItemsById(newItemConfig.id).length === 0;

          if (
            isNewItem &&
            (popout ||
              (newItemConfig.initialState == GLPopoutState.POPOUT &&
                !descriptor[CONFIG_PROPERTY_POPOUT_COMPONENT_ID]))
          ) {
            let container: any = { _config: newItemConfig };
            let component: ComponentRef<any> = goldenLayout._components[
              newItemConfig.componentName
            ](container, { componentName: newItemConfig.componentName });
            this.popupComponent(component, newItemConfig);

            if (cleanupPendingSingleton) {
              // FIXME use Promise<void> from a refactored this.popupComponent()
              this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
            }
          } else if (newItemConfig[ELEMENT_STACK_ID]) {
            // includes docking of items
            let stackId: string = newItemConfig[ELEMENT_STACK_ID];
            let stack: any = this.getStackById(stackId, goldenLayout.root);

            if (stack != null) {
              requestAnimationFrame(() => {
                stack.addChild(newItemConfig);

                if (cleanupPendingSingleton) {
                  this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
                }
              });
            } else {
              let allStacks: Array<any> = goldenLayout.root.getItemsByType("stack");
              let biggestStack: any = null;
              let maxSize: number = -1;
              for (let i: number = 0; i < allStacks.length; i++) {
                let stackElement: Element = allStacks[i].element[0] as Element;
                let rect: Rect = stackElement.getBoundingClientRect();
                let size: number = (rect.right - rect.left) * (rect.bottom - rect.top);
                if (maxSize < size) {
                  maxSize = size;
                  biggestStack = allStacks[i];
                }
              }
              requestAnimationFrame(() => {
                if (biggestStack != null) {
                  biggestStack.addChild(newItemConfig);
                } else {
                  this.addToTopLeft(goldenLayout, newItemConfig);
                }

                if (cleanupPendingSingleton) {
                  this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
                }
              });
            }
          } else if (isNewItem) {
            requestAnimationFrame(() => {
              if (descriptor.additionMode === GoldenLayoutAdditionMode.SPLIT_HORIZONTAL) {
                this.addRow(
                  goldenLayout,
                  goldenLayout.root.contentItems[0],
                  goldenLayout.root,
                  newItemConfig,
                );
              } else if (descriptor.additionMode === GoldenLayoutAdditionMode.SPLIT_VERTICAL) {
                this.addColumn(
                  goldenLayout,
                  goldenLayout.root.contentItems[0],
                  goldenLayout.root,
                  newItemConfig,
                );
              } else if (descriptor.additionMode === GoldenLayoutAdditionMode.ROOT_STACK) {
                this.addToRootStack(goldenLayout, newItemConfig);
              } else if (descriptor.additionMode === GoldenLayoutAdditionMode.NONE) {
                logger.out.info(
                  `${this.constructor.name}.newWindow() ignoring GoldenLayoutAdditionMode.NONE item`,
                );
              } /* GoldenLayoutAdditionMode.DEFAULT */ else {
                this.addToTopLeft(goldenLayout, newItemConfig);
              }

              if (cleanupPendingSingleton) {
                // FIXME use Promise<void> from a refactored this.popupComponent()
                this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
              }
            });
          } else if (!newItemConfig.preventActivation) {
            this.activateWindow(goldenLayout, newItemConfig);
            this.refreshSubject.next();

            if (cleanupPendingSingleton) {
              // FIXME use Promise<void> from a refactored this.popupComponent()
              this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
            }
          } else {
            logger.out.warn(
              `${this.constructor.name}.newWindow() no valid action found for ${newItemConfig.title} allowMultiples:${newItemConfig.allowMultiples} preventActivation:${newItemConfig.preventActivation}`,
            );

            if (cleanupPendingSingleton) {
              // FIXME use Promise<void> from a refactored this.popupComponent()
              this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
            }
          }
        } catch (e) {
          logger.out.error(
            `${this.constructor.name}.newWindow() error occured while adding control to golden layout`,
            e,
          );

          if (cleanupPendingSingleton) {
            // FIXME use Promise<void> from a refactored this.popupComponent()
            this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
          }
        }
      },
      (err: any) => {
        logger.out.error(
          `${this.constructor.name}.newWindow() golden layout initalization failed: %O`,
          err,
        );

        if (cleanupPendingSingleton) {
          // FIXME use Promise<void> from a refactored this.popupComponent()
          this.pendingSingletonNewDashbordItem.delete(dashboardItemType);
        }
      },
    );
  }

  /**
   *
   * @param descriptor
   * @param dashboardItemType
   * @returns true if an error dialog has been displayed.
   */
  private checkErrorDialogOnMultiple(descriptor: any, dashboardItemType): boolean {
    if (descriptor?.errorDialogOnMultiple) {
      let data;
      if (dashboardItemType == DashboardItemType.OrderTake) {
        data = new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_OK, null, null, {
          messages: [
            this.goldenLayoutService.translationService.instant(
              "dialog.gl.error.on.multiple.take.message",
            ),
          ],
          title: "dialog.gl.error.on.multiple.take.title",
        });
      } else if (dashboardItemType == DashboardItemType.OrderForceTake) {
        data = new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_OK, null, null, {
          messages: [
            this.goldenLayoutService.translationService.instant(
              "dialog.gl.error.on.multiple.force.take.message",
            ),
          ],
          title: "dialog.gl.error.on.multiple.force.take.title",
        });
      } else if (dashboardItemType == DashboardItemType.OrderTransfer) {
        data = new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_OK, null, null, {
          messages: [
            this.goldenLayoutService.translationService.instant(
              "dialog.gl.error.on.multiple.transfer.message",
            ),
          ],
          title: "dialog.gl.error.on.multiple.transfer.title",
        });
      } else {
        logger.out.warn(
          `${this.constructor.name}.checkErrorDialogOnMultiple() unsupported DashboardItemType.${DashboardItemType[dashboardItemType]}`,
        );
        return false;
      }
      this.goldenLayoutService.addDialog(data);
      return true;
    } else {
      logger.out.info(
        `${this.constructor.name}.checkErrorDialogOnMultiple() allowMultiples:${descriptor.allowMultiples} DashboardItemType.${DashboardItemType[dashboardItemType]}.`,
      );
      return false;
    }
  }

  getStackById(id: string, goldenLayoutItem: any): any {
    let stack: any = null;

    if (goldenLayoutItem.id == id && goldenLayoutItem.type == "stack") {
      stack = goldenLayoutItem;
    }

    let children: Array<any> = goldenLayoutItem.contentItems;
    for (let i: number = 0; stack == null && i < children.length; i++) {
      stack = this.getStackById(id, children[i]);
    }

    return stack;
  }

  activateItem(tabElement: Element): void {
    this._goldenLayout.then((goldenLayout) => {
      let stacks: Array<any> = goldenLayout.root.getItemsByType("stack");
      if (stacks.length > 0) {
        for (let i: number = 0; i < stacks.length; i++) {
          let stack = stacks[i];
          if (stack.header.tabsContainer[0] == tabElement.parentElement) {
            let tabs: Array<any> = stack.header.tabs;
            if (!this.isDesktop || NativeDesktopSupport.mainWindowLoadComplete) {
              for (let j: number = 0; j < tabs.length; j++) {
                let tab = tabs[j];
                if (tab.element[0] == tabElement) {
                  const component = tab.contentItem;
                  stack.header.removeTab(component);
                  stack.header.createTab(component, 0);
                  stack.header.setActiveContentItem(component);
                  // Make the same position change to the content items so that they will be saved in
                  // the order that the tabs appears
                  if (Array.isArray(stack.contentItems) && stack.contentItems[j] === component) {
                    logger.out.info(
                      `gl - Moving tab content '${tab.contentItem?.config?.title}' to position 0`,
                    );
                    stack.contentItems.splice(j, 1);
                    stack.contentItems.unshift(component);
                  } else {
                    logger.out.warn(
                      `Cannot find tab content at same location as tab ${tab.contentItem?.config?.title}`,
                    );
                  }
                  stack.setActiveContentItem(component);
                  return;
                }
              }
            }
          }
        }
      }
    });
  }

  activateWindow(goldenLayout: any, newItemConfig: any) {
    logger.out.warn(`${this.constructor.name}.activateWindow %O`, newItemConfig);
    goldenLayout.root.getItemsByFilter((item: any) => {
      if (item.config.id == newItemConfig.id) {
        item.parent.setActiveContentItem(item);
      }
    });
  }

  // Eventhough this is called add column, this will tile items verictcally - golden lyaout terminology so keeping it consistent
  addColumn(gl: any, existingLayount: any, parentLayout: any, newItemConfig: any) {
    logger.out.warn(`${this.constructor.name}.addColumn %O`, newItemConfig);
    if (existingLayount.isStack) {
      let newLayout = gl.createContentItem({
        type: "column",
        content: [],
        width: 100,
        height: 100,
      });
      let i;
      newLayout.isInitialised = true;
      for (i = 0; i < existingLayount.contentItems.length; i++) {
        let child: any = existingLayount.contentItems[i];
        if (child.isComponent) {
          child = gl.createContentItem({
            id: this.generateStackId(),
            type: "stack",
            content: [],
            width: 100,
            height: 100,
          });
          child.addChild(existingLayount.contentItems[i]);
        }
        newLayout.addChild(child);
      }
      parentLayout.replaceChild(existingLayount, newLayout);
      parentLayout.contentItems[0].addChild(newItemConfig);
    } else if (existingLayount.isRow) {
      let firstItemLayout = existingLayount.contentItems[0];
      this.addColumn(gl, firstItemLayout, existingLayount, newItemConfig);
    } else {
      existingLayount.addChild(newItemConfig);
    }
  }

  // Eventhough this is called add row, this will tile items horizontally - golden lyaout terminology so keeping it consistent
  addRow(gl: any, existingLayount: any, parentLayout: any, newItemConfig: any) {
    logger.out.warn(`${this.constructor.name}.addRow %O`, newItemConfig);

    if (existingLayount.isStack) {
      let newLayout = gl.createContentItem({
        type: "row",
        content: [],
        width: 100,
        height: 100,
      });
      let i;
      newLayout.isInitialised = true;
      for (i = 0; i < existingLayount.contentItems.length; i++) {
        let child: any = existingLayount.contentItems[i];
        if (child.isComponent) {
          child = gl.createContentItem({
            id: this.generateStackId(),
            type: "stack",
            content: [],
            width: 100,
            height: 100,
          });
          child.addChild(existingLayount.contentItems[i]);
        }
        newLayout.addChild(child);
      }
      parentLayout.replaceChild(existingLayount, newLayout);
      parentLayout.contentItems[0].addChild(newItemConfig);
    } else if (existingLayount.isColumn) {
      let firstItemLayout = existingLayount.contentItems[0];
      this.addRow(gl, firstItemLayout, existingLayount, newItemConfig);
    } else {
      existingLayount.addChild(newItemConfig);
    }
  }

  addToRootStack(gl: any, newItemConfig: any) {
    logger.out.warn(`${this.constructor.name}.addToRootStack %O`, newItemConfig);
    if (gl.root.contentItems.length === 0) {
      // OMS-33705
      gl.root.addChild({
        // id: this.generateStackId(),
        type: "stack",
        content: [newItemConfig],
        width: 100,
        height: 100,
      });
    } else if (
      gl.root.contentItems.length === 1 &&
      gl.root.contentItems[0].isStack &&
      gl.root.contentItems[0].contentItems.length === 0
    ) {
      // OMS-33705 a stack without content loaded from profile
      gl.root.replaceChild(gl.root.contentItems[0], {
        // id: this.generateStackId(),
        type: "stack",
        content: [newItemConfig],
        width: 100,
        height: 100,
      });
    } else if (gl.root.contentItems.length > 0 && gl.root.contentItems[0].isStack) {
      gl.root.contentItems[0].addChild(newItemConfig);
    } else if (
      gl.root.contentItems.length > 0 &&
      gl.root.contentItems[0].contentItems.length > 0 &&
      gl.root.contentItems[0].contentItems[0].isStack
    ) {
      gl.root.contentItems[0].contentItems[0].addChild(newItemConfig);
    } else {
      // can't find root stack - fallback to addRow logic
      this.addRow(gl, gl.root.contentItems[0], gl.root, newItemConfig);
    }
  }

  addToTopLeft(gl: any, newItemConfig: any) {
    let firstStack = this.getFirstStack(gl.root);
    if (firstStack) {
      logger.out.warn(`${this.constructor.name}.addToTopLeft firstStack %O`, newItemConfig);
      firstStack.addChild(
        newItemConfig,
        firstStack.contentItems.length,
        !newItemConfig.preventActivation,
      );
    } else {
      logger.out.warn(`${this.constructor.name}.addToTopLeft addToRootStack %O`, newItemConfig);
      this.addToRootStack(gl, newItemConfig);
    }
  }

  generateStackId(): string {
    return "stack-" + Math.random() * 10000;
  }

  getFirstStack(item): any {
    if (item.isStack) return item;
    for (let childItem of item.contentItems) {
      let childStack = this.getFirstStack(childItem);
      if (childStack) {
        return childStack;
      }
    }
    return null;
  }

  retrieveGoldenLayoutContent(): Promise<any> {
    return new Promise<string>((resolve, reject) => {
      this._goldenLayout.then(
        (goldenLayout: any) => {
          this.saveGoldenLayoutComponentData(goldenLayout);
          let goldenLayoutContent = goldenLayout.toConfig();
          goldenLayoutContent.creationDate = CubiqTS.moment().format();

          if (this.isDesktop) {
            this.savePopoutComponentData().then(
              (popoutConfigs: any[]) => {
                goldenLayoutContent.popout = popoutConfigs;
                goldenLayoutContent.notification = this.goldenLayoutService.getNotificationConfig();
                goldenLayoutContent.serviceProfileConfig = this.retrieveServiceProfileConfig();
                NativeDesktopSupport.getWindowConfig(
                  NativeDesktopSupport.getNativeDesktopWindow(),
                ).then((nativeWindowState: any) => {
                  // If the window is minimized I'm not sure we can trust the saved dimensions so we use hte previously stored state
                  goldenLayoutContent.nativeWindowState =
                    nativeWindowState?.state === "minimized"
                      ? this.nativeWindowState
                      : nativeWindowState;
                  logger.out.info("Saving golden layout configuration ", goldenLayoutContent);
                  resolve(goldenLayoutContent);
                });
              },
              (err) => {
                logger.out.error("Error saving popout components data. ", err);
                reject(err);
              },
            );
          } else {
            goldenLayoutContent.notification = this.notificationData;
            goldenLayoutContent.nativeWindowState = this.nativeWindowState;
            goldenLayoutContent.serviceProfileConfig = this.retrieveServiceProfileConfig();
            resolve(goldenLayoutContent);
          }
        },
        (err: any) => {
          logger.out.info("getting golden layout content failed: " + err);
          reject(err);
        },
      );
    });
  }

  private retrieveServiceProfileConfig(): object {
    return [...this.serviceProfileConfigMap.entries()].reduce(
      (obj, [componentName, serviceProfileConfig]) => {
        obj[componentName] = {
          service: serviceProfileConfig.getServiceConfiguration(),
          component: this.serviceProfileConfigComponentConfigMap.get(serviceProfileConfig),
        };
        return obj;
      },
      {},
    );
  }

  private saveGoldenLayoutComponentData(goldenLayout: any): void {
    let items: Array<any> = goldenLayout._getAllContentItems();

    items.forEach((item) => {
      if (item.instance && item.instance.instance) {
        let component: any = item.instance.instance;
        let updated = this.updateServiceProfileConfig(component);

        if (component["getComponentConfiguration"] && !updated) {
          try {
            let configData: any = component["getComponentConfiguration"]();

            if (configData != null) {
              // Verify that config data can be saved
              JSON.stringify(configData);

              item.config.data = configData;
            }
          } catch (e) {
            logger.out.error("Error saving component configuration.", e);
          }
        } else if (updated) {
          // ServiceProfileConfig
          item.config.data = null;
        }
      }
    });
  }

  private savePopoutComponentData(): Promise<any[]> {
    return new Promise<any>((res, rej) => {
      if (this.isDesktop) {
        let promises: Promise<void>[] = [];
        let popoutItems: Array<any> = this.goldenLayoutService.getPopoutComponents();
        popoutItems.forEach((popoutItem) => {
          let config: any = {};
          let component: any = popoutItem.instance;
          let updated = this.updateServiceProfileConfig(component);

          if (component["getComponentConfiguration"] && !updated) {
            try {
              let configData: any = component["getComponentConfiguration"]();
              if (configData != null) {
                // Verify that config data can be saved
                JSON.stringify(configData);

                popoutItem._config.data = configData;
              }
            } catch (e) {
              logger.out.error("Error saving component configuration.", e);
            }
          } else if (updated) {
            popoutItem._config.data = null;
          } else {
            //OMS-28156 window components with no configuration will not be saved
            return;
          }

          config.itemConfig = popoutItem._config;

          let popoutComponentId: string = config.itemConfig.popoutComponentId;
          let popout = this.goldenLayoutService.getPopout(popoutComponentId);
          let wnd = NativeDesktopSupport.getWindowByPopoutId(popoutComponentId);

          if (wnd != null) {
            let promise: Promise<any> = NativeDesktopSupport.getWindowConfig(wnd);

            promises.push(
              new Promise<any>((res, rej) => {
                promise.then((windowConf: any) => {
                  if (windowConf.state === "minimized" && popout.asMinimizedConfig != null) {
                    config.windowConfig = popout.asMinimizedConfig;
                  } else {
                    config.windowConfig = windowConf;
                  }
                  res(config);
                });
              }),
            );
          }
        });

        Promise.all(promises).then((configs: any[]) => res(configs));
      }
    });
  }

  private updateFlash(): void {
    //logger.out.warn(`${this.constructor.name}.updateFlash()`);

    this.shouldFlash = !this.shouldFlash;

    this._goldenLayout.then((goldenLayout: any) => {
      if (goldenLayout.root != null) {
        let flashingComponents = [];

        if (this.isDesktop) {
          flashingComponents.push(...this.goldenLayoutService.getPopoutComponents());
        }

        flashingComponents.push(...goldenLayout.root.getItemsByType("component"));

        flashingComponents.forEach((item: any) => {
          if (
            item.instance != null &&
            item.instance.instance != null &&
            item.instance.instance["getAlertStatus"]
          ) {
            let flashState: GLComponentAlertStatus = item.instance.instance["getAlertStatus"]();

            const element: HTMLElement = item.container?.tab?.element?.[0];
            let classList: DOMTokenList = element?.classList;

            // handle classes
            switch (flashState) {
              case GLComponentAlertStatus.ALERT:
                if (!classList.contains("lm-alert-active")) {
                  classList.add("lm-alert-active");
                }
                classList.remove("alert_hco");
                classList.remove("alert_sco");
                break;
              case GLComponentAlertStatus.ALERT_FLASH:
                if (!classList.contains("lm-alert-active")) {
                  classList.add("lm-alert-active");
                }
                classList.remove("alert_hco");
                classList.remove("alert_sco");
                break;
              case GLComponentAlertStatus.HCO_FLASH:
                if (!classList.contains("alert_hco")) {
                  classList.add("alert_hco");
                }
                classList.remove("alert_sco");
                classList.remove("noflash");
                this.flashTab(classList, this.shouldFlash);
                break;
              case GLComponentAlertStatus.HCO:
                if (!classList.contains("alert_hco")) {
                  classList.add("alert_hco");
                }
                classList.remove("alert_sco");
                classList.remove("flash");
                classList.add("noflash");
                break;
              case GLComponentAlertStatus.SCO_FLASH:
                if (!classList.contains("alert_sco")) {
                  classList.add("alert_sco");
                }
                classList.remove("alert_hco");
                classList.remove("noflash");
                this.flashTab(classList, this.shouldFlash);
                break;
              case GLComponentAlertStatus.SCO:
                if (!classList.contains("alert_sco")) {
                  classList.add("alert_sco");
                }
                classList.remove("alert_hco");
                classList.remove("flash");
                classList.add("noflash");
                break;
              case GLComponentAlertStatus.NONE:
                classList.remove("lm-alert-active");
                classList.remove("flash");
                classList.remove("alert_hco");
                classList.remove("alert_sco");
                classList.remove("noflash");
                break;
            }
          }
        });
      }
    });
  }

  private flashTab(classList, shouldFlash): void {
    if (shouldFlash) {
      classList.add("flash");
    } else {
      classList.remove("flash");
    }
  }

  private updateServiceProfileConfig(component: GoldenLayoutComponent) {
    let service =
      typeof component.glComponentIsSingleton === "function" &&
      component.glComponentIsSingleton() &&
      typeof component.glServiceProfileConfig === "function" &&
      component.glServiceProfileConfig() != null &&
      typeof component.getComponentConfiguration === "function"
        ? component.glServiceProfileConfig()
        : null;

    if (service != null) {
      this.serviceProfileConfigComponentConfigMap.set(
        service,
        component.getComponentConfiguration(),
      );
      return true;
    }

    return false;
  }

  private updateContainerConfigData(container: {
    title: string;
    componentRef: ComponentRef<any>;
    _config: any;
  }): void {
    let component = container.componentRef.instance;

    if (component == null) {
      logger.out.warn(
        `${this.constructor.name}.updateContainerConfigData() could` +
          ` not find component for ${
            container != null ? `container title:${container.title}` : `null`
          }`,
      );
    }

    let service =
      typeof component.glComponentIsSingleton === "function" &&
      component.glComponentIsSingleton() &&
      typeof component.glServiceProfileConfig === "function" &&
      component.glServiceProfileConfig() != null &&
      typeof component.getComponentConfiguration === "function"
        ? component.glServiceProfileConfig()
        : null;

    if (service != null && this.serviceProfileConfigComponentConfigMap.has(service)) {
      container._config.data = this.serviceProfileConfigComponentConfigMap.get(service);
    }
  }

  /**
   *  walk content for to validate that componentName is registered
   * remove missing with a warning
   */
  private validiateProfileConfiguration(config: any) {
    if (!config || !Array.isArray(config.content)) {
      return this.canViewOrderBlotters
        ? this.getDefaultConfiguration()
        : this.getEmptyConfiguration();
    }

    let maxDepth = 10;
    let depth = 0;
    let configItem = config;
    let seenIds = new Set<string>();
    let singletonIds: Set<string> = new Set();

    let nativePopoutSingleInstance: Set<string> =
      // OMS-33706 ignore when in browser mode
      this.isDesktop && Array.isArray(config.popout)
        ? new Set(
            config.popout
              .filter(
                (p) =>
                  p != null &&
                  typeof p === "object" &&
                  p.itemConfig != null &&
                  typeof p.itemConfig === "object" &&
                  typeof p.itemConfig.componentName === "string" &&
                  p.itemConfig.allowMultiples === false,
              )
              .map((p) => p.itemConfig.componentName),
          )
        : new Set();

    const invalidFilterFn = (item, i): boolean => {
      if (depth > maxDepth) {
        throw new Error("validiateProfileConfiguration max depth exceeded");
      }

      if (item && item.type && "component" === item.type) {
        let isValid =
          this.componentNames.has(item.componentName) &&
          nativePopoutSingleInstance.has(item.componentName) === false &&
          singletonIds.has(item.componentName) === false;

        if (item.allowMultiples === false) {
          singletonIds.add(item.componentName);
        }

        if (isValid && !!item.id) {
          seenIds.add(item.id);
          if (this.isDesktop === false) {
            // saving profile from browser
            // should not store previous undock position
            delete item["windowConfig"];
          }
        }

        if (!isValid) {
          logger.out.info(
            `${this.constructor.name}.validateProfileConfiguration() dropping item missing from application or configuration: ${item.componentName}`,
          );
          if (configItem.activeItemIndex == 0) {
            // NOP - nobody here but us chickens
          } else if (configItem.activeItemIndex == i) {
            // if we remove the active one rebase it.
            configItem.activeItemIndex = 0;
          } /* if (configItem.activeItemIndex >= i) */ else {
            // NB - we want to lower the actve index if we remove one /*below it*/
            configItem.activeItemIndex = configItem.activeItemIndex - 1;
          }
        }

        return isValid;
      } else if (item && Array.isArray(item.content)) {
        depth++;
        let oldConfigItem = configItem;
        configItem = item;
        item.content = item.content.filter(invalidFilterFn);
        configItem = oldConfigItem;
        depth--;

        if (Array.isArray(item.content) && item.content.length == 0) {
          return false;
        }
      }

      return true;
    };

    config.content = config.content.filter(invalidFilterFn);

    // workaround OMS-23033
    if (!!config.maximisedItemId) {
      if (!seenIds.has(config.maximisedItemId)) {
        // delete config['maximisedItemId'];
        logger.out.warn(
          `${this.constructor.name}: removing invalid maximisedItemId to workaround OMS-23033`,
        );
      }
    }

    return config;
  }

  private getDefaultConfiguration(): any {
    const doc = DomHandler.getDocument(this.GoldenLayoutElement);
    const headerHeight = BFXDomHelper.getVariablePx(doc, "--ds-cont-sizing-common-md", 30);
    let config: any = {
      content: [
        {
          width: 100,
          height: 100,
          type: "stack",
          content: [
            {
              title: "Order Blotter",
              id: "Orders 1",
              type: "component",
              componentName: "bfx-blotter-orders",
              componentType: DashboardItemType.OrdersBlotter,
              width: 100,
              height: 100,
            },
          ],
        },
      ],
      dimensions: { headerHeight },
    };

    return config;
  }

  private getEmptyConfiguration(): any {
    const doc = DomHandler.getDocument(this.GoldenLayoutElement);
    const headerHeight = BFXDomHelper.getVariablePx(doc, "--ds-cont-sizing-common-md", 30);
    let config: any = {
      content: [],
      dimensions: { headerHeight },
    };

    return config;
  }
}
